/* eslint-disable react-hooks/exhaustive-deps */
import { IconX } from "@tabler/icons-react";
import SelectInput from "../../../components/Select";
import {
  FieldErrors,
  UseFormClearErrors,
  UseFormRegister,
  UseFormSetValue,
} from "react-hook-form";
import Input from "../../../components/Input";
import { useEffect } from "react";
import NewSelectInput from "../../../components/NewSelectInput";
import NewinputField from "../../../components/NewInput";
import { useLanguage } from "../../../context/LanguageContext";

type Forword3PlModalProps = {
  open: boolean;
  onClose: () => void;
  register: UseFormRegister<any>;
  errors: FieldErrors<any>;
  setValue: UseFormSetValue<any>;
  watch: any;
  clearErrors: UseFormClearErrors<any>;
  handleSubmit: React.MouseEventHandler<HTMLButtonElement>;
  data: any;
  isPending?: boolean;
  inPlace?: boolean;
};

export default function Forword3PlModal({
  open,
  onClose,
  setValue,
  errors,
  register,
  watch,
  handleSubmit,
  data,
  isPending,
  inPlace = false,
}: Forword3PlModalProps) {
  const { t } = useLanguage();
  useEffect(() => {
    setValue("noOfPieces", 1);
  }, []);

  if (!open) return null;

  if (inPlace) {
    return (
      <div className="bg-white backdrop-blur-md border border-slate-200/80 shadow-sm rounded-2xl overflow-hidden flex flex-col">
        <div className="flex justify-between items-center px-5 py-4 border-b border-slate-100 bg-white">
          <h3 className="text-lg font-bold text-[#212121]">
            {t("Forwarded 3PL Company")}
          </h3>
          <div className="flex items-center gap-2">
            <button
              type="button"
              onClick={handleSubmit}
              disabled={isPending}
              className="p-1.5 px-4 rounded-lg text-xs font-semibold transition-all duration-200 flex items-center justify-center bg-[#FBD037] hover:bg-[#f7c400] text-black shadow hover:shadow-md cursor-pointer disabled:opacity-50 disabled:cursor-not-allowed"
            >
              {isPending ? (
                <svg
                  className="animate-spin h-4 w-4 text-black"
                  viewBox="0 0 24 24"
                >
                  <circle
                    className="opacity-25"
                    cx="12"
                    cy="12"
                    r="10"
                    stroke="currentColor"
                    strokeWidth="4"
                  ></circle>
                  <path
                    className="opacity-75"
                    fill="currentColor"
                    d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                  ></path>
                </svg>
              ) : (
                t("Send")
              )}
            </button>
            <button
              type="button"
              onClick={onClose}
              className="p-1.5 rounded-lg border border-[#D2D2D2] hover:bg-gray-100 transition-colors text-slate-700"
            >
              <IconX size={16} />
            </button>
          </div>
        </div>

        {/* Body */}
        <div className="group  rounded-2xl bg-gradient-to-b from-white/90 to-white/60 backdrop-blur-xl border border-[#D2D2D2]/70 p-4 m-4 transition-all duration-300 space-y-3">
          <div className="grid grid-cols-3 gap-4">
            <div className="absolute inset-0 rounded-3xl bg-gradient-to-tr from-yellow-200/20 to-transparent pointer-events-none" />
            <NewSelectInput
              name="3plCompany"
              label={t("3PL Company")}
              placeholder=""
              className="flex items-center gap-2 col-span-2"
              selectOptions={
                data?.map((company: any) => ({
                  id: company?.id,
                  value: company?.id,
                  text: company?.companyName,
                })) || []
              }
              register={register}
              validation={{ required: t("3PL Company is required") }}
              error={errors.countryId}
              disabled={!data || data.length === 0}
              value={watch("3plCompany")}
              setValue={(val: string) => setValue("3plCompany", val)}
            />
            <NewinputField
              title={t("Pieces")}
              placeholder="2"
              className="flex items-center gap-2"
              name="noOfPieces"
              register={register}
              error={errors.noOfPieces}
              validation={{ required: t("No of pieces is required") }}
            />
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="fixed top-0 left-0 w-full h-screen bg-black/60 z-50 flex items-center justify-end p-4">
      <div className="rounded-2xl w-full max-w-[500px] h-[calc(100vh-2rem)] flex flex-col relative bg-gradient-to-tr from-[#FDF8E5] to-[#FAF8EC] shadow-2xl overflow-hidden animate-in fade-in slide-in-from-right duration-300">
        <div className="flex items-center justify-between px-6 py-4 border-b border-[#d2d2d2] flex-shrink-0">
          <h2 className="text-2xl font-bold">{t("Forwarded 3PL Company")}</h2>
          <button
            onClick={onClose}
            className="bg-[#F2F2F7] rounded-full p-1 cursor-pointer w-12 h-12 flex items-center justify-center flex-shrink-0"
          >
            <IconX size={20} />
          </button>
        </div>

        <div className="w-full flex-1 overflow-y-auto p-6 space-y-4 bg-gradient-to-tr from-[#FDF8E5] to-[#FAF8EC] scrollbar-clean">
          <div className="bg-white p-4 rounded-xl shadow-md space-y-4">
            <SelectInput
              name="3plCompany"
              label={t("Select 3PL Company")}
              placeholder=""
              className="w-full"
              selectOptions={
                data?.map((company: any) => ({
                  id: company?.id,
                  value: company?.id,
                  text: company?.companyName,
                })) || []
              }
              register={register}
              validation={{ required: t("3PL Company is required") }}
              error={errors.countryId}
              disabled={!data || data.length === 0}
              value={watch("3plCompany")}
              setValue={(val: string) => setValue("3plCompany", val)}
            />
            <Input
              title={t("No. of Pieces")}
              placeholder="2"
              className="w-full"
              name="noOfPieces"
              register={register}
              error={errors.noOfPieces}
              validation={{ required: t("No of pieces is required") }}
            />
          </div>
        </div>

        <div className="border-t border-[#D8D8D8] px-6 py-4 flex justify-end gap-2 bg-gradient-to-tr from-[#FDF8E5] to-[#FAF8EC] flex-shrink-0">
          <button
            onClick={onClose}
            className="w-full sm:w-auto h-11 px-6 rounded-full border border-[#D8D8D8] bg-white hover:bg-[#F5F5F5] transition-all duration-200 font-medium cursor-pointer"
          >
            {t("Cancel")}
          </button>
          <button
            onClick={handleSubmit}
            disabled={isPending}
            className="w-full sm:w-auto min-w-[140px] h-11 px-6 rounded-full font-semibold transition-all duration-200 flex items-center justify-center gap-2 bg-[#FBD037] hover:bg-[#f7c400] text-black shadow-lg hover:shadow-xl cursor-pointer disabled:opacity-50 disabled:cursor-not-allowed"
          >
            {isPending ? (
              <svg
                className="animate-spin h-5 w-5 text-black"
                viewBox="0 0 24 24"
              >
                <circle
                  className="opacity-25"
                  cx="12"
                  cy="12"
                  r="10"
                  stroke="currentColor"
                  strokeWidth="4"
                ></circle>
                <path
                  className="opacity-75"
                  fill="currentColor"
                  d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                ></path>
              </svg>
            ) : (
              <>
                <span className="mr-2">{t("Send")}</span>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  className="h-4 w-4"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                  strokeWidth={2}
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    d="M5 12h14M12 5l7 7-7 7"
                  />
                </svg>
              </>
            )}
          </button>
        </div>
      </div>
    </div>
  );
}
